import { defineStore } from "pinia";
import type { SearchKeywordRes,SearchKeywordReq,SearchByCityRes,SearchByCityReq,HotelDetail,BookingHotelRes,BookingHotelReq,listPayments,createPaymentRequest,createPaymentResponse,DetaiReportlHotel,ReportHotel } from "~/istypes";
import { useUserStore} from "~/stores/user";

export const useNewsStore = defineStore('news', () => {
    const config = useRuntimeConfig();
    const userStore = useUserStore();

    const getNews = async () => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/supports/news`,{
                    method: "POST",
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });
                
                return res;

            }catch(error){
                return error;
            }
        }
    }

    const countNews = async() => {
        const response: any = await getNews();
        return response.details.news.length
    }

    const getBanner = async () => {
        try{
            const res = await $fetch<any>(`${config.public.ApiBase}/banners/home`,{
                method: "POST",
                headers: {
                    "Device-Id": userStore.deviceId(),
                }
            });
            
            return res;

        }catch(error){
            return error;
        }
    }


    return { getNews,getBanner,countNews };
});